import { Controller } from '@hotwired/stimulus';

// Connects to data-controller="form-modal"
// Used in: districts/no_newecomer_period/payment_infos/students and default forms
// Purpose: open and close form modal and stop scroll
// Explanation: this controller could be combined with the timetable modal controller
export default class extends Controller {
  static targets = ['modal'];

  connect() {
    console.log('form modal controller connected :)');
  }

  openModal() {
    console.log('openModal');
    this.modalTarget.classList.remove('hidden');
    document.querySelector('body').classList.add('overflow-hidden');
  }

  submit() {
    console.log('submit');
  }

  closeModal() {
    this.modalTarget.classList.add('hidden');
    document.querySelector('body').classList.remove('overflow-hidden');
  }

  disconnect() {
    console.log('Disconnected form modal controller');
    document.querySelector('body').classList.remove('overflow-hidden');
  }
}
